import { c as _c } from "react/compiler-runtime";
import { Box, Button, HStack, Heading, Icon, SimpleGrid, Spacer, Stack, VStack, Flex } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { ArticleStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ArticleStep';
import { ComponentStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ComponentStep';
import { ContentStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ContentStep';
import { PodcastStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/PodcastStep';
import { VideoStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/VideoStep';
import { Prompt } from '@src/components/sco/Education/ContentTrackStepDetail/Tasks/Prompt';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { ViewableTracker } from '@src/components/sco/ViewableTracker';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ContentTrackStep } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
import { BiLinkExternal } from 'react-icons/bi';
import { LuMicroscope } from 'react-icons/lu';
type StepProps = {
  contentTrackStep: ContentTrackStep;
};
export const Step = props => {
  const $ = _c(61);
  const trackContext = useContentTrackContext();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const step = props.contentTrackStep;
  const hasBody = !!step.body;
  const hasTasks = step.tasks.length > 0;
  const hasVideo = !!step.video?.sourceUrl;
  let t0;
  if ($[0] !== step.contentAttachments) {
    t0 = step.contentAttachments?.find(_temp);
    $[0] = step.contentAttachments;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasPodcast = !!t0;
  let t1;
  if ($[2] !== step.contentAttachments) {
    t1 = step.contentAttachments?.find(_temp2);
    $[2] = step.contentAttachments;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasArticle = !!t1;
  const hasComponent = !!step.customReactComponent?.componentKey;
  let T0;
  let T1;
  let T2;
  let T3;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== getBreakpointValue || $[5] !== hasArticle || $[6] !== hasBody || $[7] !== hasComponent || $[8] !== hasPodcast || $[9] !== hasTasks || $[10] !== hasVideo || $[11] !== props.contentTrackStep || $[12] !== step || $[13] !== trackContext.contentTrackEnrollment?.contentTrackEnrollmentId) {
    const renderContent = () => <>{renderVideo()}{renderPodcast()}{renderBody()}{renderArticle()}{renderComponent()}{renderTasks()}</>;
    const renderVideo = () => {
      if (!hasVideo) {
        return null;
      }
      return <VideoStep contentTrackStep={props.contentTrackStep} playbackEndInSeconds={props.contentTrackStep.video.playbackEndInSeconds} playbackStartInSeconds={props.contentTrackStep.video.playbackStartInSeconds} sourceUrl={props.contentTrackStep.video.sourceUrl} />;
    };
    const renderPodcast = () => {
      if (!hasPodcast) {
        return null;
      }
      return <>{step.contentAttachments.filter(_temp3).map(podcastEpisode => <Box backdropFilter="blur(5px)" bgColor={`${step.parentContentTrackSection.parentContentTrack.color?.hex}40`} borderRadius="3xl" boxShadow="sm" padding={4} transition="all 0.2s ease-in" width="full"><Box borderRadius="xl" boxShadow="base" overflow="hidden"><PodcastStep contentTrackStep={props.contentTrackStep} podcastEpisode={podcastEpisode} /></Box></Box>)}<Spacer height={getBreakpointValue([4, 6, 8, 10])} /></>;
    };
    const renderBody = () => {
      if (!hasBody) {
        return null;
      }
      return <Box height="full" width="full"><Box bgColor="colorPalette.container" borderRadius="3xl" borderTop="1px solid rgba(255, 255, 255, 0.08)" height="full" padding={getBreakpointValue([10, 10, 12])} position="relative" width="full" boxShadow="rgba(0, 0, 0, 0.2) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 5px 10px, rgba(0, 0, 0, 0.2) 0px 15px 30px"><Box height="full"><ContentStep body={step.body} color={step.parentContentTrackSection.parentContentTrack.color?.hex} contentTrackStep={props.contentTrackStep} title={step.title} /></Box></Box><Spacer height={getBreakpointValue([4, 6, 8, 10])} /></Box>;
    };
    const renderArticle = () => {
      if (!hasArticle) {
        return null;
      }
      return <Box borderRadius="3xl" width="full">{step.contentAttachments.filter(_temp4).map(article => <ArticleStep article={article} contentTrackStep={props.contentTrackStep} />)}<Spacer height={getBreakpointValue([4, 6, 8, 10])} /></Box>;
    };
    const renderComponent = () => {
      if (!hasComponent) {
        return null;
      }
      return <ComponentStep component={step.customReactComponent} contentTrackStep={props.contentTrackStep} />;
    };
    const renderTasks = () => {
      if (!hasTasks) {
        return null;
      }
      return <VStack align="flex-start" bgColor="colorPalette.container" borderRadius="3xl" borderTop="1px solid rgba(255, 255, 255, 0.08)" gap={10} height="full" maxWidth={getBreakpointValue([null, null, null, "container.lg"])} padding={getBreakpointValue([8, 8, 10])} position="relative" width="full"><HStack align="center"><Icon asChild={true}><LuMicroscope /></Icon><Heading size="xs">Exercises</Heading></HStack><SimpleGrid columns={1} gap={10} width="full">{step.tasks.map(task => {
            if (task.action.__typename === "ContentTrackPrompt") {
              return <Box width="full"><PaywalledAction contentPermission="canAccessFGDashboard" title="Become a Basic Member to access this Course Exercise." variant="boxed"><Prompt contentTrackStep={step} prompt={task.action} task={task} /></PaywalledAction></Box>;
            }
            if (task.action.__typename === "ContentTrackCallToAction") {
              return <Stack align="center" bgColor={`${props.contentTrackStep.parentContentTrackSection.parentContentTrack.color?.hex}50`} borderRadius="lg" direction="row" justify="space-between" padding="2em" width="full"><Heading>{task.action.title || task.title}</Heading><NextLink href={task.action.callToActionUrl} prefetch={false} target="_blank"><Button bgColor={`${props.contentTrackStep.parentContentTrackSection.parentContentTrack.color?.hex}`} size="lg">Let's do it!<BiLinkExternal /></Button></NextLink></Stack>;
            }
            if (task.action.__typename === "ContentTrackReactComponent") {
              return <Box bgColor="colorPalette.container" marginBottom="1em" padding="1em" width="full">Task: Component</Box>;
            }
          })}</SimpleGrid></VStack>;
    };
    T3 = Box;
    t15 = "full";
    t16 = "full";
    T2 = ViewableTracker;
    t10 = trackContext.contentTrackEnrollment?.contentTrackEnrollmentId;
    t11 = "ContentTrackEnrollment";
    t12 = true;
    t13 = props.contentTrackStep.id;
    t14 = props.contentTrackStep.__typename;
    T1 = Flex;
    t5 = "center";
    t6 = "column";
    t7 = "flex-start";
    if ($[33] !== getBreakpointValue) {
      t8 = getBreakpointValue([4, 6, 8, 10]);
      $[33] = getBreakpointValue;
      $[34] = t8;
    } else {
      t8 = $[34];
    }
    t9 = "full";
    T0 = Box;
    t2 = "container.lg";
    t3 = "full";
    t4 = renderContent();
    $[4] = getBreakpointValue;
    $[5] = hasArticle;
    $[6] = hasBody;
    $[7] = hasComponent;
    $[8] = hasPodcast;
    $[9] = hasTasks;
    $[10] = hasVideo;
    $[11] = props.contentTrackStep;
    $[12] = step;
    $[13] = trackContext.contentTrackEnrollment?.contentTrackEnrollmentId;
    $[14] = T0;
    $[15] = T1;
    $[16] = T2;
    $[17] = T3;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    T0 = $[14];
    T1 = $[15];
    T2 = $[16];
    T3 = $[17];
    t10 = $[18];
    t11 = $[19];
    t12 = $[20];
    t13 = $[21];
    t14 = $[22];
    t15 = $[23];
    t16 = $[24];
    t2 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
  }
  let t17;
  if ($[35] !== T0 || $[36] !== t2 || $[37] !== t3 || $[38] !== t4) {
    t17 = <T0 maxWidth={t2} width={t3}>{t4}</T0>;
    $[35] = T0;
    $[36] = t2;
    $[37] = t3;
    $[38] = t4;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== T1 || $[41] !== t17 || $[42] !== t5 || $[43] !== t6 || $[44] !== t7 || $[45] !== t8 || $[46] !== t9) {
    t18 = <T1 align={t5} direction={t6} justify={t7} padding={t8} width={t9}>{t17}</T1>;
    $[40] = T1;
    $[41] = t17;
    $[42] = t5;
    $[43] = t6;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== T2 || $[49] !== t10 || $[50] !== t11 || $[51] !== t12 || $[52] !== t13 || $[53] !== t14 || $[54] !== t18) {
    t19 = <T2 parentId={t10} parentType={t11} trackScrolling={t12} viewableId={t13} viewableType={t14}>{t18}</T2>;
    $[48] = T2;
    $[49] = t10;
    $[50] = t11;
    $[51] = t12;
    $[52] = t13;
    $[53] = t14;
    $[54] = t18;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  let t20;
  if ($[56] !== T3 || $[57] !== t15 || $[58] !== t16 || $[59] !== t19) {
    t20 = <T3 height={t15} width={t16}>{t19}</T3>;
    $[56] = T3;
    $[57] = t15;
    $[58] = t16;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  return t20;
};

// Placeholder Box to retain space
const PlaceholderBox = t0 => {
  const $ = _c(3);
  const {
    width,
    height
  } = t0;
  let t1;
  if ($[0] !== height || $[1] !== width) {
    t1 = <Box bgColor="containerAlpha.500" border="4px dashed" borderColor="colorPalette.borderAlpha.800" borderRadius="3xl" height={height} width={width} />;
    $[0] = height;
    $[1] = width;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
Step.fragments = {
  Article: () => gql`
    fragment _ on Article {
      id
      title
      slug
      body
    }
  `,
  PodcastEpisode: () => gql`
    fragment _ on PodcastEpisode {
      id
      slug
      transistorLink
    }
  `,
  ContentTrackPrompt: () => gql`
    fragment _ on ContentTrackPrompt {
      id
      body
      exampleResponse
      inputLabel
      responseType
      title
    }
  `,
  ContentTrackCallToAction: () => gql`
    fragment _ on ContentTrackCallToAction {
      id
      callToActionUrl
    }
  `,
  ContentTrackReactComponent: () => gql`
    fragment _ on ContentTrackReactComponent {
      id
      componentKey
      propsAsJson
    }
  `
};
function _temp(a) {
  return a.__typename == "PodcastEpisode";
}
function _temp2(a_0) {
  return a_0.__typename == "Article";
}
function _temp3(a_1) {
  return a_1.__typename === "PodcastEpisode";
}
function _temp4(a_2) {
  return a_2.__typename === "Article";
}